module.exports = __webpack_public_path__ + "img/home_banner.77bc1326.jpg";